import {env} from "../config/environment";
import {Navigate, Outlet} from "react-router-dom";
import {RoutePaths} from "../config/routeConstants";

const RegistrationFeatureGuard = () => {
    if (!env.registrationEnabled) {
        return <Navigate to={RoutePaths.Login} replace />;
    }
    return <Outlet />;
};

export default RegistrationFeatureGuard;